import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star } from "lucide-react";
import { api } from "@/lib/api";

// Rotating approved review, changes every 4s. Yellow stars, first name, small grey text.
export function ReviewTicker({ variant = "center" }) {
  const [reviews, setReviews] = useState([]);
  const [i, setI] = useState(0);

  useEffect(() => {
    let ok = true;
    api.get("/reviews/approved").then(({ data }) => { if (ok) setReviews(data.reviews || []); }).catch(() => {});
    return () => { ok = false; };
  }, []);

  useEffect(() => {
    if (reviews.length < 2) return;
    const t = setInterval(() => setI((v) => (v + 1) % reviews.length), 4000);
    return () => clearInterval(t);
  }, [reviews]);

  if (reviews.length === 0) return null;
  const r = reviews[i % reviews.length];

  return (
    <div className={`review-ticker review-ticker--${variant}`} data-testid="review-ticker" aria-live="polite">
      <AnimatePresence mode="wait">
        <motion.div
          key={r.id + "-" + i}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -6 }}
          transition={{ duration: 0.5 }}
          className="review-ticker-inner"
          data-testid="review-ticker-item"
        >
          <div className="review-stars" aria-label={`${r.rating} sur 5`}>
            {Array.from({ length: 5 }).map((_, s) => (
              <Star key={s} size={13} className={s < r.rating ? "star-on" : "star-off"} fill={s < r.rating ? "currentColor" : "none"} strokeWidth={s < r.rating ? 0 : 1.5} />
            ))}
          </div>
          {r.comment && <p className="review-ticker-text">« {r.comment} »</p>}
          <p className="review-ticker-name">— {r.name}</p>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
